import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putItem } from '../Api'

export default generateApiAction({
  baseType: Types.ITEMS.PUT,
  api: putItem,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/items/PutAction.js